import { styled, css } from 'styled-components';
import { dontForwardProps } from '../../../util';
export const DrawerOverflow = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-a1mazr-0"
})(["z-index:2147482647;position:fixed;top:0;left:0;right:0;bottom:0;width:100%;box-sizing:border-box;", ""], ({
  isOpen
}) => !isOpen && css(["pointer-events:none;"]));